import React, { useState, useEffect } from 'react';
import FilterModal from '../Modal/FilterModal';
import {
  filterButton
} from '../Pagination/FilterStyles';
import { Button } from 'app/src/elements/buttons';
import * as Colors from '../../styles/colors';
import DateRange from './DateRange';
import FilterSelect from './Select';
import styled from '@emotion/styled';

const Filter = ({clearFilters, children, filters, setFilters, filterType}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        style={filterButton}
        label="Filter Options"
        onPress={() => setShowModal(true)}
      />
      {
        showModal &&
          <FilterModal
            setShowModal={setShowModal}
            clearFilters={clearFilters}
            children={children}
          />
      }
    </>
  );
};

Filter.DateRange = DateRange;
Filter.FilterSelect = FilterSelect;

export default Filter;
